const LOADING_MEMES = 'LOADING_MEMES'
const SET_MEMES = 'SET_MEMES'
const GEN_RANDOM_MEME = 'GEN_RANDOM_MEME'
const CLEAR_MEME = 'CLEAR_MEME'
const ADD_SAVED_MEME = 'ADD_SAVED_MEME'
const LOADING_SAVED_MEMES = 'LOADING_SAVED_MEMES'
const SET_SAVED_MEMES = 'SET_SAVED_MEMES'
const DELETE_MEME = 'DELETE_MEME'
const PREVIEW_MEME = 'PREVIEW_MEME'

const LOADING_GIFS = 'LOADING_GIFS'
const SET_QUERIED_GIFS = 'SET_QUERIED_GIFS'
const GEN_RANDOM_GIF = 'GEN_RANDOM_GIF'
const SET_QUERY_INPUT = 'SET_QUERY_INPUT'
const CLEAR_GIF = 'CLEAR_GIF'
const ADD_SAVED_GIF = 'ADD_SAVED_GIF'
const LOADING_SAVED_GIFS = 'LOADING_SAVED_GIFS'
const SET_SAVED_GIFS = 'SET_SAVED_GIFS'
const DELETE_GIF = 'DELETE_GIF'

const LOADING_CAPTIONS = 'LOADING_CAPTIONS'
const SET_CAPTIONS = 'SET_CAPTIONS'
const GEN_RANDOM_CAPTIONS_ALL = 'GEN_RANDOM_CAPTIONS_ALL'
const GEN_RANDOM_CAPTIONS_PG = 'GEN_RANDOM_CAPTIONS_PG'
const GEN_RANDOM_CAPTIONS_R = 'GEN_RANDOM_CAPTIONS_R'
const SET_CHOSEN_CAPTION = 'SET_CHOSEN_CAPTION'
const CLEAR_CHOSEN_CAPTION = 'CLEAR_CHOSEN_CAPTION'
const CLEAR_CAPTIONS = 'CLEAR_CAPTIONS'
const ADD_SAVED_CAPTION = 'ADD_SAVED_CAPTION'
const CAPTION_ERRORS = 'CAPTION_ERRORS'
const CLEAR_ERRORS = 'CLEAR_ERRORS'
const PREVIEW_CAPTION = 'PREVIEW_CAPTION'
const CLEAR_PREVIEW_CAPTION = 'CLEAR_PREVIEW_CAPTION'

const SET_USER = 'SET_USER'
const LOGGED_IN = 'LOGGED_IN'
const LOGGED_OUT = 'LOGGED_OUT'
const CLEAR_USER = 'CLEAR_USER'
const USER_ERRORS = 'USER_ERRORS'
const CLEAR_CAPTION_ERRORS = 'CLEAR_CAPTION_ERRORS'
const SET_TOKEN = 'SET_TOKEN'

const DELETE_CAPTION_JOIN = 'DELETE_CAPTION_JOIN'

export {
    LOADING_MEMES,
    SET_MEMES,
    GEN_RANDOM_MEME,
    CLEAR_MEME,
    ADD_SAVED_MEME,
    LOADING_SAVED_MEMES,
    SET_SAVED_MEMES,
    DELETE_MEME,
    PREVIEW_MEME,

    LOADING_GIFS,
    SET_QUERIED_GIFS,
    GEN_RANDOM_GIF,
    SET_QUERY_INPUT,
    CLEAR_GIF,
    ADD_SAVED_GIF,
    LOADING_SAVED_GIFS,
    SET_SAVED_GIFS,
    DELETE_GIF,

    LOADING_CAPTIONS,
    SET_CAPTIONS,
    GEN_RANDOM_CAPTIONS_ALL,
    GEN_RANDOM_CAPTIONS_PG,
    GEN_RANDOM_CAPTIONS_R,
    SET_CHOSEN_CAPTION,
    CLEAR_CHOSEN_CAPTION,
    CLEAR_CAPTIONS,
    ADD_SAVED_CAPTION,
    CAPTION_ERRORS,
    CLEAR_CAPTION_ERRORS,
    PREVIEW_CAPTION,
    CLEAR_PREVIEW_CAPTION,

    SET_USER,
    LOGGED_IN,
    LOGGED_OUT,
    CLEAR_USER,
    USER_ERRORS,
    CLEAR_ERRORS,
    SET_TOKEN,

    DELETE_CAPTION_JOIN
}